import {
  HomeOutlined,
  BulbOutlined,
  ExceptionOutlined,
  CodepenCircleOutlined,
  ShopOutlined,
  ApiOutlined,
  LoginOutlined,
  ExperimentOutlined,
  SketchOutlined,
  ReloadOutlined,
  SearchOutlined,
  CheckCircleTwoTone,
  LogoutOutlined,
  SendOutlined,
  DeleteOutlined,
  UploadOutlined,
  EditOutlined,
  ClockCircleOutlined,
  DownloadOutlined,
  UserOutlined,
  CloseCircleOutlined,
  CheckOutlined,
  FileOutlined,
  CameraOutlined,
  InfoOutlined,
  EyeOutlined,
  PrinterOutlined,
  FilterOutlined,
  QrcodeOutlined,
  GlobalOutlined,
  IssuesCloseOutlined,
  ExclamationCircleFilled,
} from "@ant-design/icons";

const IconCombine = {
  HomeOutlined,
  BulbOutlined,
  ExceptionOutlined,
  CodepenCircleOutlined,
  ShopOutlined,
  ApiOutlined,
  LoginOutlined,
  ExperimentOutlined,
  SketchOutlined,
  ReloadOutlined,
  SearchOutlined,
  CheckCircleTwoTone,
  LogoutOutlined,
  SendOutlined,
  DeleteOutlined,
  UploadOutlined,
  EditOutlined,
  ClockCircleOutlined,
  DownloadOutlined,
  UserOutlined,
  CloseCircleOutlined,
  CheckOutlined,
  FileOutlined,
  CameraOutlined,
  InfoOutlined,
  EyeOutlined,
  PrinterOutlined,
  FilterOutlined,
  QrcodeOutlined,
  GlobalOutlined,
  IssuesCloseOutlined,
  ExclamationCircleFilled,
};
export default IconCombine;
